import { render, staticRenderFns } from "./RegistryDocumentView.vue?vue&type=template&id=39215a10&scoped=true&"
import script from "./RegistryDocumentView.vue?vue&type=script&lang=js&"
export * from "./RegistryDocumentView.vue?vue&type=script&lang=js&"
import style0 from "./RegistryDocumentView.vue?vue&type=style&index=0&id=39215a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39215a10",
  null
  
)

export default component.exports